

export default function OverwriteSigninButton() {

  const hideFormErrorContainer = () => {
    let formErrorContainer = document.querySelector(".o-form-error-container.o-form-has-errors");

    if(formErrorContainer)
      formErrorContainer.style.display = "none";
  }

  const handleClick = (e) => {
    e.preventDefault();

    hideFormErrorContainer();

    const emailElement = document.getElementById("okta-signin-username");
    const passwordElement = document.getElementById("okta-signin-password");
    const emailInputElement = document.querySelector(".o-form-input-name-username");
    const passwordInputElement = document.querySelector(".o-form-input-name-password");
    const buttonElement = document.getElementById("okta-signin-submit");
    const signinBrandError = document.getElementById("signin-brand-error");
    const signinBrandSelectElement = document.getElementById("signin-brand-selector");
    
    const hasEmail = emailElement.value.length > 0;
    const hasPassword = passwordElement.value.length > 0;
    const hasSelectedBrand = sessionStorage.getItem("selected-brand")?.length > 0;

    if(hasSelectedBrand){
      buttonElement.click();
    }else if(!hasEmail || !hasPassword){
      buttonElement.click();
    }

    setTimeout(() => {
      
      hideFormErrorContainer();

      if(hasSelectedBrand) {
        signinBrandError.style.display = "none";
        signinBrandSelectElement.style.borderColor = "#bbb";

        if(!hasEmail){
          emailInputElement.style.borderColor = "#B00121";  

        }else{
          emailInputElement.style.borderColor = "#bbb";   
        }
  
        if(!hasPassword){
          passwordInputElement.style.borderColor = "#B00121";
        }else{
          passwordInputElement.style.borderColor = "#bbb";   
        }
      }else{
        signinBrandError.style.display = "block";
        signinBrandSelectElement.style.borderColor = "#B00121";
      }
    }, 100);

  }
  
  return (
    <input class="button button-primary" type="button" value="Sign In" id="overwrite-signin-submit" onClick={handleClick}/>
  );
}